if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute("data-product-handle")}"]`,
        );
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();
        });
      }

      disconnectedCallback() {}

      // 🟢 1. 修正首屏初始化生命周期
      initialize() {
        this.updateOptions();
        this.updateMasterId();

        // 在注入新 HTML 前，必须让 gallery-section 干净地销毁旧 Swiper 实例
        const gallerySection = document.getElementById(`MediaGallery-${this.dataset.section}`);
        if (gallerySection && typeof gallerySection.destroyCarouselGallery === 'function') {
          gallerySection.destroyCarouselGallery();
        }

        // 强行刷入首屏的干净 DOM 节点
        this.updateVariantGallery();
        this.updateVariantModalGallery();
        this.updateVariantDimension();

        // 重新唤醒并初始化 Swiper 框架
        if (gallerySection && typeof gallerySection.initializeCarouselGallery === 'function') {
          gallerySection.initializeCarouselGallery();
        }

        this.updateGallery();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
        
        // 挂载拖拽与高亮同步骨架
        this.setupSwiperSyncListener(gallerySection);
      }

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
        }
      }

      // 🟢 2. 修正规格切换生命周期
      onVariantChange() {
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);
        
        this.updateOptions();
        this.updateMasterId();

        const gallerySection = document.getElementById(`MediaGallery-${this.dataset.section}`);
        
        // 🟢 【核心修复 1】在清空前，强制锁定画廊的物理高度，防止页面塌陷弹跳
        if (gallerySection) {
          gallerySection.style.minHeight = `${gallerySection.offsetHeight}px`;
        }

        if (gallerySection && typeof gallerySection.destroyCarouselGallery === 'function') {
          gallerySection.destroyCarouselGallery();
        }

        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateDropdownButtons();

        this.updateVariantGallery();
        this.updateVariantModalGallery();
        this.updateVariantDimension();

        if (gallerySection && typeof gallerySection.initializeCarouselGallery === 'function') {
          gallerySection.initializeCarouselGallery();
        }

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          this.lenOfVariantOptions = document.querySelectorAll("variant-options").length;
          if (this.lenOfVariantOptions === 1) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        }

        this.setupSwiperSyncListener(gallerySection);

        // 🟢 【核心修复 2】等待一切渲染就绪，新图片就位后，温柔地释放高度锁定
        if (gallerySection) {
          setTimeout(() => {
            gallerySection.style.minHeight = '';
          }, 400); // 给图片渲染留出 400ms 缓冲
        }

        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      // 🟢 3. 核心：建立【手动拖拽 / 滑动主图 -> 缩略图反向高亮】的绝对监听器
      setupSwiperSyncListener(gallerySection) {
        if (!gallerySection) return;
        
        // 轮询 300ms 确保重组后的 Swiper 已经成功初始化完毕
        let retryCount = 0;
        const checkActiveSwiper = setInterval(() => {
          const swiperInstance = gallerySection.gallerySwiper || gallerySection.swiper;
          retryCount++;

          if (swiperInstance && swiperInstance.on) {
            clearInterval(checkActiveSwiper);

            const doSync = () => {
              const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
              if (!activeSlide) return;

              const currentMediaId = activeSlide.getAttribute('data-media-id');
              if (!currentMediaId) return;

              const thumbItems = gallerySection.querySelectorAll('[data-thumbs] .thumbs-list-item');
              let targetThumb = null;

              thumbItems.forEach((thumb) => {
                if (thumb.getAttribute('data-slide-media-id') === currentMediaId) {
                  thumb.classList.add('is-active');
                  targetThumb = thumb;
                } else {
                  thumb.classList.remove('is-active');
                }
              });
            };

            swiperInstance.on('slideChange', doSync);
            doSync(); // 首屏进来立刻高亮一次
          }

          if (retryCount > 15) clearInterval(checkActiveSwiper);
        }, 40);
      }

      updateVariantGallery() {
        if (!this.currentVariant) return;
        const variantId = this.currentVariant.id;
        const wrapper = document.querySelector('.variant_imgs_activated');
        if (!wrapper) return;

        const dataEl = document.getElementById('variant_metafield_data');
        if (!dataEl) return;

        let map = {};
        try { map = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }

        const mediaList = map[variantId];
        if (!Array.isArray(mediaList) || mediaList.length === 0) return;

        wrapper.innerHTML = '';
        mediaList.forEach((item, index) => {
          const url = item.startsWith('//') ? `https:${item}` : item;
          const mediaId = `${variantId}-${index}`;
          const li = document.createElement('li');
          li.className = 'swiper-slide wt-masonry__slide';
          li.setAttribute('data-swiper-slide', '');
          li.setAttribute('data-media-id', mediaId);
          li.id = `image-${index + 1}`;
          li.style.setProperty('--slide-ratio', '1.0');
          li.innerHTML = `
            <a href="${url}&width=4096" target="_blank" tabindex="0" data-pswp-width="2000" data-pswp-height="2000">
              <img src="${url}&width=600" srcset="${url}&width=500 500w, ${url}&width=750 750w, ${url}&width=1000 1000w" sizes="(min-width: 900px) 50vw, 100vw" alt="" width="1100" height="1100" data-media-id="${mediaId}" class="wt-product__img wt-product__img--zoom-cursor" ${index === 0 ? 'fetchpriority="high"' : 'loading="lazy"'}>
            </a>`;
          wrapper.appendChild(li);
        });
      }

      updateVariantModalGallery() {
        if (!this.currentVariant) return;
        const variantId = this.currentVariant.id;
        const wrapper = document.querySelector('.thumbs-list');
        if (!wrapper) return;

        const dataEl = document.getElementById('variant_metafield_data');
        if (!dataEl) return;

        let map = {};
        try { map = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }

        const mediaList = map[variantId];
        if (!Array.isArray(mediaList) || mediaList.length === 0) return;

        wrapper.innerHTML = '';
        mediaList.forEach((item, index) => {
          const url = item.startsWith('//') ? `https:${item}` : item;
          const mediaId = `${variantId}-${index}`;
          const li = document.createElement('li');
          li.className = 'thumbs-list-item swiper-slide wt-slider__slide';
          li.setAttribute('data-swiper-slide', '');
          li.setAttribute('data-slide-media-id', mediaId);
          li.style.setProperty('--thumb-ratio', '1.0');
          li.style.setProperty('margin-right', '8px');
          li.tabIndex = -1;
          li.innerHTML = `
            <div>
              <img src="${url}&width=300" alt="" loading="lazy" width="300" height="300" data-media-id="${mediaId}" class="wt-product__img">
            </div>`;
          wrapper.appendChild(li);
        });
      }

      updateVariantDimension() {
        const container = document.querySelector('.variant_dimensions');
        if (!container) return;
        const dataEl = document.getElementById('variant_metafield_dimension_data');
        if (!dataEl) return;
        let dimensionMap = {};
        try { dimensionMap = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }
        container.innerHTML = '';
        const variantId = this.currentVariant.id;
        container.innerHTML = dimensionMap[variantId] || '';
      }

      updateGallery() {
        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }
        try { mediaGallery?.filterSlides(this.options, media_id, true); } catch (error) {}
      }

      updateDropdownButtons() {
        const fieldsets = Array.from(this.querySelectorAll(".wt-product__option"));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked)?.value || '';
        });
        fieldsets.forEach((fieldset) => {
          const dropdown = fieldset.querySelector(".wt-product__option__dropdown");
          if (dropdown) {
            const checkedInput = fieldset.querySelector('fieldset input:checked');
            if (!checkedInput) return;
            dropdown.classList.toggle('wt-product__option__dropdown--unavailable', checkedInput.classList.contains('disabled'));
          }
        });
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll(".wt-product__option"));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked)?.value || "";
        });
        this.checkedOptions = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked) || '';
        });
        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.options[index];
          if (!selectedOption) return;
          fieldset.querySelector(".wt-product__option__title .value").innerHTML = selectedOption;
          const dropdownSpan = fieldset.querySelector(".wt-product__option__dropdown span");
          if (dropdownSpan) dropdownSpan.innerHTML = selectedOption;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options.map((option, index) => this.options[index] === option).includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute("data-featured-image", this.currentVariant?.featured_media?.preview_image?.src);
        this.setAttribute("data-featured-image-id", this.currentVariant?.featured_media?.id);
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        if (newMediaModal) modalContent.prepend(newMediaModal);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
      }

      updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (input) {
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData?.filter((variant) => variant.available === true);
        const inputWrappers = [...this.querySelectorAll(".product-form__input")];
        const checkedInputs = [...this.querySelectorAll('.product-form__input :checked')];
        const checkedInputsValues = checkedInputs.map(input => input.getAttribute('value'));
        const previousSelectedOptions = [];
        inputWrappers.forEach((option, index) => {
          if (index === 0 && this.currentVariant?.options.length > 1) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const previousOptionSelected = inputWrappers[index - 1]?.querySelector(":checked")?.value;
          previousSelectedOptions.push(previousOptionSelected);
          const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => {
            if (index === 2) {
              return variant.available && variant[`option1`] === previousSelectedOptions[0] && variant[`option2`] === previousSelectedOptions[1];
            } else {
              return variant.available && variant[`option${index}`] === previousOptionSelected;
            }
          }).map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue, checkedInputsValues, index, checkedInputs);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions, checkedInputsValues, index, checkedInputs) {
        function containsSubarray(arr, subarr) { return arr.join(',').includes(subarr.join(',')); }
        const checkedValues = checkedInputsValues.slice(0, index);
        const listOfAvailableVariants = this.getVariantData().filter(variant => {
          if (containsSubarray(variant.options, checkedValues)) return true;
        });
        const isPreviousOptionChecked = checkedInputs.find(input => input.dataset.position === `${index}`) || index === 0;
        listOfOptions.forEach((input) => {
          if (!isPreviousOptionChecked) return;
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
          } else {
            input.classList.add("disabled");
          }
          let inputOccurs = false;
          listOfAvailableVariants.forEach(variant => {
            if (variant.options.includes(input.getAttribute("value"))) inputOccurs = true;
          });
          if (!inputOccurs) input.classList.add("disabled");
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector("pickup-availability");
        if (!pickUpAvailability) return;
        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;
        const productForm = section.querySelector("product-form");
        try { productForm?.handleErrorMessage(); } catch (err) {}
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant?.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            if (this.currentVariant?.id !== requestedVariantId) return;
            const html = new DOMParser().parseFromString(responseText, "text/html");
            const destination = document.getElementById(`price-${this.dataset.section}`);
            const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
            const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"));
            }
            const price = document.getElementById(`price-${this.dataset.section}`);
            if (price) price.classList.remove("visibility-hidden");
            if (inventoryDestination) inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");

            const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
            this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true, window.variantStrings.soldOut);

            publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: sectionId, html, variant: this.currentVariant } });
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }
    },
  );
}